module.exports = __webpack_public_path__ + "img/seaarch.0f099ac1.png";